// sealy UtilityPage body. `UtilityPageBodyContent` = the 30 Toolbox keys + 4
// page-specific keys (plus a re-declared `rich_text` the shared map already
// dispatches). The body loop emits NO per-block Wagtail wrapper
// (tagName={React.Fragment}). warranty_form renders the
// `<section class="warranty-form-block">` wrapper around the shared WarrantyForm
// island (sealy's property-name / claim-URL constants); the wrapper lives here
// because the dispatcher bypasses the per-block template.
import { Immutable } from "immer";
import React from "react";
import { WarrantyForm } from "tsi-common-react/src/components/WarrantyForm/index";

import { templates } from "@reactivated";
import type { SharedWarrantyForm as WarrantyFormValue } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { AccordianList } from "../../blocks/AccordianList";
import { SpecialOfferList } from "../../blocks/SpecialOfferList";
import { WarrantyFrame } from "../../blocks/WarrantyFrame";
import { toolboxComponentsMap } from "../../blocks/toolboxComponentsMap";

const SEALY_WARRANTY_PROPERTY_NAME = "Sealy";
const SEALY_WARRANTY_CLAIM_URL =
    "https://help.sealy.com/hc/en-us/requests/new?ticket_form_id=1500003086321";

export const utilityPageComponentsMap = {
    ...toolboxComponentsMap,
    accordian_list: AccordianList,
    special_offers_list: SpecialOfferList,
    warranty_frame: WarrantyFrame,
    warranty_form: (block: { value: Immutable<WarrantyFormValue> }) => (
        <section className="warranty-form-block">
            <WarrantyForm
                value={block.value}
                propertyName={SEALY_WARRANTY_PROPERTY_NAME}
                claimURL={SEALY_WARRANTY_CLAIM_URL}
            />
        </section>
    ),
} as const;

type IBodyValue = templates.UtilityPageTemplate["page"]["body"]["value"];

export const UtilityPageBody = (
    props: Immutable<{ value: IBodyValue }>,
): React.JSX.Element => (
    <StreamField
        tagName={React.Fragment}
        value={props.value}
        components={utilityPageComponentsMap}
    />
);
